module.exports = __webpack_public_path__ + "img/gz.f9401be9.png";